/**
 * Farm2Feed.js
 * Farmville2 feeds implemented under right rail.
 */
import React from 'react'
import BaseComponent from '../../../../BaseComponent';
import $ from 'jquery';
import './Farm2Feeds.css'
import '../rail/Rail.css'
import '../../../../../../styles/generic.css'
import LocUtils from '../../../../../util/localization/LocUtils';
import FlipMove from "react-flip-move";
import Farm2FeedController from './feedHelpers/Farm2FeedController';
import ServiceLocator from '../../../../../ServiceLocator';
import ZPersona from '../../../../../managers/SocialNetwork/People/ZPersona/ZPersona';
import Button from '../../../../minions/buttons/Buttons';
import SiteConstants from "../../../../../util/SiteConstants";

class ToggleSwitch extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            selected: "everybody"
        }
        this.switchPress = this.switchPress.bind(this);
    }

    switchPress(evt) {
        if (!evt || !evt.target || !evt.target.value) return;
        switch (evt.target.value) {
            case "zfriends":
                if (this.state.selected !== "zFriends") {
                    this.setState({
                        selected: "zfriends"
                    }, () => {
                        ServiceLocator.ZTrack.Cast({
                            counter: "click",
                            kingdom: "right-rail",
                            phylum: "switch",
                            zClass: "toggle",
                            family: "zfriends"
                        })
                        this.props.onSwitchChange(true);
                    })
                }
                break;
            case "everybody":
                if (this.state.selected !== "everybody") {
                    this.setState({
                        selected: "everybody"
                    }, () => {
                        ServiceLocator.ZTrack.Cast({
                            counter: "click",
                            kingdom: "right-rail",
                            phylum: "switch",
                            zClass: "toggle",
                            family: "everybody"
                        })
                        this.props.onSwitchChange(false);
                    })
                }
                break;
            default:
                return;
        }
    }

    render() {
        return (
            <div id="feed-toggle-container" className="farm2-feed-switch rounded-corners-bottom">
                {/* <span className="farm2-feed-switch-text">{LocUtils.T("pages.games.farm2.rail.switch.everybody")}</span>&nbsp;&nbsp;
                <label className="switch">
                    <input onClick={this.switchPress} type="checkbox" />
                    <span className="slider round"></span>
                </label>
                &nbsp;&nbsp;<span className="farm2-feed-switch-text">{LocUtils.T("pages.games.farm2.rail.switch.myZFriends")}</span> */}

                <div className="rail-tab">
                    <button className={(this.state.selected === "zfriends" ? "switchActive " : "") + " tablinks rail-button-left"} value="zfriends" onClick={this.switchPress}>{LocUtils.T("pages.games.farm2.rail.switch.myZFriends")}</button>
                    <button className={(this.state.selected === "everybody" ? "switchActive " : "") + "tablinks rail-button-right"} value="everybody" onClick={this.switchPress}>{LocUtils.T("pages.games.farm2.rail.switch.everybody")}</button>
                </div>
            </div>
        )
    }
}

class Farm2FeedButton extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            current_state: "NORMAL",
            status_text: ""
        }
        // debug
        this.availableStates = {
            "SUCCESS": "SUCCESS",
            "ACCEPT_LIMIT_REACHED": "ACCEPT_LIMIT_REACHED",
            "ACCEPT_DUPLICATE": "ACCEPT_DUPLICATE",

            "2": "Too many accepted rewards recently of this type/already accepted",
            "4": "parnet is OOR",
            "0": "OK",
        }
        this.buttonStates = {
            "-3": "NORMAL",
            "-2": "UNKNOWN",
            "-1": "ENGAGED",
            "0": "SUCCESS",
            "1": "UNKNOWN",    // possibly "ACCEPT_LIMIT_REACHED": "Daily limit reached!"
            "2": "DUPLICATE",
            "3": "UNKNOWN",    // possibly "ACCEPT_EXPIRED": "Expired",
            "4": "PARTNER_LIMIT_REACHED",
            "5": "UNKNOWN",    // possibly: "ACCEPT_NOT_FOUND": "Oops! That didn't work!",
            "6": "UNKNOWN"     // possibly: doesnt exists
        }
        this.buttonStateStyles = {
            "ENGAGED": {
                text: LocUtils.T("pages.games.farm2.rail.claim_button.PLEASE_WAIT"),
                cls: " badge badge-secondary feed-btn-engaged "
            },
            "NORMAL": {
                text: this.props.ctaText,
                cls: " btn btn-outline-secondary div-button feed-btn-clickable "
            },
            "DUPLICATE": {
                text: LocUtils.T("pages.games.farm2.rail.claim_button.ACCEPT_DUPLICATE"),
                cls: " badge badge-warning feed-btn-disbaled "
            },
            "PARTNER_LIMIT_REACHED": {
                text: LocUtils.T("pages.games.farm2.rail.claim_button.ACCEPT_OUT_OF_REWARDS"),
                cls: " badge badge-warning feed-btn-disbaled "
            },
            "SUCCESS": {
                text: LocUtils.T("pages.games.farm2.rail.claim_button.SUCCESS"),
                cls: " badge badge-success feed-btn-disabled "
            },
            "UNKNOWN": {
                text: "Error",
                cls: " badge badge-danger feed-btn-disbaled "
            }
        }

        this.onClaim = this.onClaim.bind(this);
        this.progressState = this.progressState.bind(this);
    }

    componentDidMount() {
        if (this.props.data.claim_data) {
            this.setState({
                current_state: this.props.data.claim_data.current_state,
                status_text: this.props.data.claim_data.status_text
            })
        }
    }

    progressState(to, statusMessage) {
        to = (to === undefined) ? "-1" : "" + to;
        if (!this.buttonStates[to]) {
            alert("Found unknown state number: " + to);
            alert(statusMessage);
            to = "-2";
        }
        this.setState({
            current_state: this.buttonStates[to],
            status_text: statusMessage
        }, () => {
            Farm2FeedController.ClaimedUpdate(this.props.chnl, this.props.id, this.state.current_state, this.state.status_text)
        })
    }

    onClaim() {
        if (this.state.current_state === "NORMAL") {
            var l = new URL(this.props.href);
            var viralHref = l.pathname + l.search;
            super.log("Attempting to claim: ", viralHref, this.props.chnl);
            Farm2FeedController.Claim.Try(this, {
                href: viralHref,
                chnl: this.props.chnl
            });
            var phylumStr = "feeds_"
            if(this.props.data && this.props.data.cta) {
                phylumStr = "feeds_" + this.props.data.cta.replaceAll(" ", "_")
            }
            ServiceLocator.ZTrack.Cast({
                counter: "click",
                kingdom: "right-rail",
                phylum: phylumStr,
                zClass: this.props.chnl,    // Could be either zynga, zfriend
                family: "claim",
                genus: "attempt"
            });
            this.progressState();
        }
    }

    render() {
        return (
            <div>
                <div id={"bt-" + this.props.id}
                    onClick={this.onClaim}
                    className={this.buttonStateStyles[this.state.current_state].cls} >
                    {this.buttonStateStyles[this.state.current_state].text}
                </div>
                &nbsp;&nbsp;
              <div className={
                    (this.state.current_state === "NORMAL" || this.state.current_state === "ENGAGED"
                        ? "feed-status-hide"
                        : ""
                    ) + " feed-tooltip feed-status-icon"} >
                    <span className="feed-tooltiptext">{this.state.status_text}</span>
                </div>
            </div>
        )
    }
}

class Farm2FeedX extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            engaged: false,
            key: props.key,
            azid : props.data.azid,
            imgSrc: this.props.userLookup(this.props.data.azid).apicurl || this.props.userLookup(this.props.data.azid).profilePicThumb
        }
        this.onImage404 = this.onImage404.bind(this);
        this.onAdd = this.onAdd.bind(this);
    }

    onImage404() {
        let dummyPersona = ServiceLocator.SocialNetworkManager.People.Directory.Lookup("undefined");
        if (dummyPersona) {
            this.setState({
                imgSrc: dummyPersona.profilePicThumb
            })
        }
    }

    onAdd() {

        let zidToUse;
        if (ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.SideRail.ADD_FRIEND_TEST_MODE_EXPERIMENT) === 2) {
            const userInputZid = prompt("Enter zid (leave blank to use default):");
            zidToUse = userInputZid && userInputZid.trim() !== "" ? userInputZid.trim() : this.state.azid;
        } else {
            zidToUse = this.state.azid;
        }


        this.setState({
            engaged: true
        }, () => {
            ServiceLocator.SocialNetworkManager.People.AddOneFriend({
                suggestedZid: zidToUse,
                gameId: 1031
            }, (data) => {
                if (data["msg"] === "DAY_LIMIT_EXCEEDED") {
                    ServiceLocator.ZTrack.Cast({
                        counter: "click",
                        kingdom: "right-rail",
                        phylum: "add-friend",
                        zClass: "fail",
                        family: "day-limit"
                    });
                    if (this.props.setFriendRequestSendLimitReached) {
                        this.props.setFriendRequestSendLimitReached(true);
                    }
                } else {
                    ServiceLocator.ZTrack.Cast({
                        counter: "click",
                        kingdom: "right-rail",
                        phylum: "add-friend",
                        zClass: "success",
                        family: "add"
                    });
                    if (this.props.addRequestedFriendZid) {
                        this.props.addRequestedFriendZid(this.state.azid);
                    }
                }

            }, (err) => {
                ServiceLocator.ZTrack.Cast({
                    counter: "click",
                    kingdom: "right-rail",
                    phylum: "add-friend",
                    zClass: "fail",
                    family: "errort"
                });
            });
        })
    }

    render() {
        // console.log("rendering FEEDX");
        return (
            <div key={this.props.key} id={this.props.data.id} className="farm2-feed ">
                <div className="row no-gutters">
                    <div className="col-2 "><img className="farm2-feed-item-pic " src={this.props.data.img} alt="." /></div>
                    <div style={{ fontSize: "0.35em", paddingLeft: "0.8rem" }} className="col-10 ">
                        <div className="row no-gutters feed-body"><div className="col-2 "><img className="farm2-feed-user-pic " onError={this.onImage404} src={this.state.imgSrc} alt="p" /></div><div className="col farm2-feed-item-body"><span className="feed-header">{this.props.userLookup(this.props.data.azid).afullname}</span><br></br>{this.props.data.desc}</div></div>
                        <div className="row no-gutters ">
                            <div style={{ left: "10px", top: "-5px" }} className="col ">
                                <div className="d-flex flex-wrap align-items-start">
                                    <div style={{ whiteSpace: "nowrap" }}>
                                        <Farm2FeedButton id={this.props.data.id} ctaText={this.props.data.cta} href={this.props.data.href} chnl={this.props.data.chnl} data={this.props.data} authData={this.props.authData} className="feed-button" />
                                    </div>
                                    {typeof this.props.getFriendRequestState === "function" && this.props.getFriendRequestState(this.state.azid) === 0 && !this.props.isFriendRequestSendLimitReached && (
                                        <div className="ms-2" style={{ whiteSpace: "nowrap", marginTop: '3px' }}>
                                            <Button
                                                severity="transparent-black"
                                                message={this.state.engaged
                                                    ? <span><i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={{ fontSize: "1rem" }}></i>&nbsp;{LocUtils.T("pages.games.farm2.rail.friends.wait")}</span>
                                                    : <span><i className="fa fa-user-plus fa-3x fa-fw" style={{ fontSize: "1rem" }}></i>&nbsp;{LocUtils.T("pages.games.farm2.rail.friends.add")}</span>}
                                                extraClass="suggested-button"
                                                onClick={this.onAdd}
                                            />
                                        </div>
                                    )}
                                    {typeof this.props.getFriendRequestState === "function" && this.props.getFriendRequestState(this.state.azid) === 0 && this.props.isFriendRequestSendLimitReached &&  (
                                        <div className="ms-2" style={{ whiteSpace: "nowrap", marginTop: '10px' }}>
                                            <Button
                                                severity="info"
                                                message={<span><i className="fa fa-user-plus fa-3x fa-fw" style={{ fontSize: "1rem" }}></i>&nbsp;{LocUtils.T("pages.games.farm2.rail.friends.add")}</span>}
                                                extraClass="suggested-button"
                                            />
                                        </div>
                                    )}
                                    {typeof this.props.getFriendRequestState === "function" && this.props.getFriendRequestState(this.state.azid) === 1 && (
                                        <div className="ms-2" style={{ whiteSpace: "nowrap", marginTop: '3px' }}>
                                            <Button
                                                severity="transparent-black"
                                                message={<span><i className="fa fa-paper-plane fa-3x fa-fw" style={{ fontSize: "1rem" }}></i>&nbsp;{LocUtils.T("pages.games.farm2.rail.friends.requested")}</span>}
                                                extraClass="side-rail-add-friends-button"
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr className="feedSubHeaderHr" />
            </div>
        )
    }
}

class ContactCard extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            zid: props.zPersona.zid,
            imgSrc: props.zPersona.profilePicThumb,
            engaged: false,
            rejecting: false,
        }
        this.onAdd = this.onAdd.bind(this);
        this.onReject = this.onReject.bind(this);
        this.onImage404 = this.onImage404.bind(this);
    }

    onImage404() {
        let dummyPersona = ServiceLocator.SocialNetworkManager.People.Directory.Lookup("undefined");
        if (dummyPersona) {
            this.setState({
                imgSrc: dummyPersona.profilePicThumb
            })
        }
    }

    onAdd() {
        this.setState({
            engaged: true
        }, () => {
            ServiceLocator.SocialNetworkManager.People.Friend({
                suggestedZid: this.state.zid,
                gameId: 1031
            });
            ServiceLocator.ZTrack.Cast({
                counter: "click",
                kingdom: "right-rail",
                phylum: "friend-finder",
                zClass: "contact-card",
                family: "add"
            });
            setTimeout(() => {
                this.setState({
                    engaged: false
                });
                // Tell parent to dismiss
                this.props.onDismiss(this.state.zid);
            }, 1000);
        })
    }

    onReject() {
        this.setState({
            rejecting: true
        }, () => {
            ServiceLocator.ZTrack.Cast({
                counter: "click",
                kingdom: "right-rail",
                phylum: "friend-finder",
                zClass: "contact-card",
                family: "reject"
            });
            ServiceLocator.SocialNetworkManager.People.Reject({
                rejectZid: this.state.zid,
                gameId: 1031
            }, () => {
                this.setState({ rejecting: false })
                this.props.onDismiss(this.state.zid);
            }, () => {
                this.setState({ rejecting: false })
                this.props.onDismiss(this.state.zid);
            })
        })
    }

    render() {
        return (
            <div>
                <div className="row no-gutters suggested-contact-container">
                    <div className="col-3 suggested-picture-container">
                        <img src={this.props.zPersona.profilePicThumb} alt="p"
                            onError={this.onImage404}
                            className="suggested-picture" />
                    </div>
                    <div className="col suggested-data-container">
                        <div className="row no-gutters">
                            <div className="col suggested-data-field">
                                {((this.props.zPersona.firstName + " " + this.props.zPersona.lastName).length > 1)
                                    ? this.props.zPersona.firstName + " " + this.props.zPersona.lastName
                                    : this.props.zPersona.displayName}
                            </div>
                        </div>
                        <div className="row no-gutters">
                            <div className="col suggested-data-field">
                                <Button
                                    severity="transparent-black"
                                    message={this.state.engaged
                                        ? <span><i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={{ fontSize: "1rem" }}></i>&nbsp;{LocUtils.T("pages.games.farm2.rail.friends.wait")}</span>
                                        : LocUtils.T("pages.games.farm2.rail.friends.add")}
                                    onClick={this.onAdd} extraClass="suggested-button" />
                            </div>
                        </div>
                    </div>
                    {/* The (X) close button */}
                    <button type="button" className="close suggested-reject" aria-label="Close"
                        onClick={this.onReject}>
                        {
                            this.state.rejecting
                            && <span><i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw" style={{ fontSize: "1rem" }}></i></span>
                        }
                        {
                            !this.state.rejecting
                            && <span aria-hidden="true">&times;</span>
                        }
                    </button>
                </div>
                <hr className="frndSubHeaderHr" />
            </div>
        )
    }
}

class SuggestedFriends extends BaseComponent {

    constructor(props) {
        super(props);
        this.state = {
            opened: true,
            loading: false,
            noMore: false,
            friendSuggestions: []
        }
        // this.friendSuggestions = [];
        this.onToggle = this.onToggle.bind(this);
        this.reloadFriendSuggestions = this.reloadFriendSuggestions.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
    }

    onToggle() {
        const opened = this.state.opened;
        this.setState({
            opened: !opened
        }, () => {
            ServiceLocator.ZTrack.Cast({
                counter: "click",
                kingdom: "right-rail",
                phylum: "friend-finder",
                zClass: "toggle",
                family: this.state.opened
            });
        })
    }

    reloadFriendSuggestions() {
        this.setState({
            loading: true
        }, () => {
            ServiceLocator.SocialNetworkManager.People.GetSuggested({ gameId: 1031 }, (data) => {
                console.log("+++==> got: ", data);
                if (data.recs) {
                    ServiceLocator.SocialNetworkManager.People.Directory.Identify(data.recs, (data) => {
                        console.log("identified: ", data);
                        let toShow = [];
                        if (data.e !== undefined && data.e === 0) {
                            data = data.users;
                            Object.keys(data).forEach(zid => {
                                toShow.push(new ZPersona(data[zid]))
                            })
                            console.log("Toshow is; ", toShow);
                        } else if (Array.isArray(data)) {
                            // if they are zpersonas?
                            data.forEach(sample => {
                                if (sample instanceof ZPersona) {
                                    toShow.push(sample);
                                }
                            })
                        }
                        if (toShow.length > 0) {
                            let totalSuggestions = this.state.friendSuggestions.concat(toShow);
                            this.setState({
                                loading: false,
                                noMore: false,
                                friendSuggestions: totalSuggestions
                            })
                        } else {
                            // Try in some time
                            this.setState({
                                noMore: true,
                                loading: false
                            }, () => {
                                setTimeout(this.reloadFriendSuggestions, 40000);
                            })
                        }
                    })
                }
            })
        })
    }

    componentDidMount() {
        // Keep the undefined rendered
        ServiceLocator.SocialNetworkManager.People.Directory.Identify("undefined");
        this.reloadFriendSuggestions();
    }

    onDismiss(zid = undefined) {
        if (!zid) return;
        let remainingSuggestions = this.state.friendSuggestions.filter(function (value, index, arr) {
            return value.zid !== zid;
        })
        this.setState({
            friendSuggestions: remainingSuggestions
        })
    }

    render() {
        return (
            <div>
                <p onClick={this.onToggle} className="h6 div-button text-black feedSubHeader" data-toggle="collapse" data-target="#suggestedFriendsCollapse" aria-expanded="false" aria-controls="suggestedFriendsCollapse">
                    {/* <p className="div-button h6 text-white"> */}
                    <i className="fa fa-user-plus" aria-hidden="true"></i>
                    &nbsp;&nbsp;
                    <b>{LocUtils.T("pages.games.farm2.rail.friends.title")}</b>
                    &nbsp;&nbsp;
                    <i className={(this.state.opened
                        ? "feedSubHeaderArrowRotate90"
                        : "feedSubHeaderArrowRotate0") + " fa fa-arrow-circle-right"} aria-hidden="true"></i>
                </p>
                <div className="row no-gutters">
                    <div className="col">
                        <div className={" collapse multi-collapse show"} id="suggestedFriendsCollapse" >
                            {
                                (!!this.state.noMore || (!this.state.noMore && !this.state.loading && this.state.friendSuggestions.length === 0))
                                && <p class="h6 text-black feedSubHeader">{LocUtils.T("pages.games.farm2.rail.friends.no_more")}</p>
                            }
                            {
                                !this.state.noMore && !!this.state.loading
                                && <span>
                                    <i className="fa fa-circle-o-notch fa-spin fa-3x fa-fw text-white" style={{ fontSize: "1rem" }}></i>
                                </span>
                            }
                            {
                                !this.state.noMore && !this.state.loading
                                && this.state.friendSuggestions.length > 0
                                && <div className="suggested-scrollable-container">
                                    {
                                        this.state.friendSuggestions.map((suggestion, key) => {
                                            return <ContactCard key={suggestion.zid} zPersona={suggestion} onDismiss={this.onDismiss} />
                                        })
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <hr className="activitySubHr" />
            </div>
        )
    }
}

class FeedFilter extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            filterButtons: [
                {
                    icon: "/filter_bottle.png",
                    label: LocUtils.T("pages.games.farm2.rail.feedFilter.babyBottle"),
                    searchKeyWords: ["baby bottle", "sutteflaske", "Babyfläschchen", "biberón", "biberon", "biberon", "mamadeirinha", "nappflaska", "tåteflaske"],
                    key: "bottle"
                },
                {
                    icon: "/filter_water.png",
                    label: LocUtils.T("pages.games.farm2.rail.feedFilter.water"),
                    searchKeyWords: ["water", "vand", "Wasser", "agua", "eau", "acqua", "água", "vatten", "vann"],
                    key: "water"
                },
                {
                    icon: "/filter_power.png",
                    label: LocUtils.T("pages.games.farm2.rail.feedFilter.power"),
                    searchKeyWords: ["power", "strøm", "Power", "energía", "énergie", "energia", "energia", "kraft", "kraft"],
                    key: "power"
                },
                {
                    icon: "/filter_postingredient.png",
                    label: LocUtils.T("pages.games.farm2.rail.feedFilter.featureIngredient"),
                    excludeKeyWords: [
                        "baby bottle", "water", "power", "xp", "coins", "fuel", "surprise item", "bait", "kindling", "feed",
                        "sutteflaske", "vand", "strøm", "XP", "mønter", "brændstof", "overraskelsesgenstand", "madding", "pindebrænde", "foder",
                        "Babyfläschchen", "Wasser", "Power", "EP", "Münzen", "Kraftstoff", "Überraschungsgegenstand", "Köder", "Feuerholz", "Füttern",
                        "biberón", "agua", "energía", "XP", "monedas", "combustible", "objeto sorpresa", "cebo", "montones de astillas", "pienso",
                        "biberon", "eau", "énergie", "XP", "pièces", "carburant", "objet surprise", "appât", "brindille", "nourriture",
                        "biberon", "acqua", "energia", "XP", "monete", "carburante", "sorpresa", "esca", "fuscelli", "mangime",
                        "mamadeirinha", "água", "energia", "EXP", "moedas", "combustível", "item surpresa", "isca", "acendedor", "ração",
                        "nappflaska", "vatten", "kraft", "xp", "mynt", "bränsle", "överraskningsföremål", "bete", "tändved", "foder",
                        "tåteflaske", "vann", "kraft", "xp", "mynter", "drivstoff", "overraskelsesgjenstand", "agn", "opptenningsved", "fôr"
                    ],
                    key: "Post Ingredients"
                },
            ],
            selectedFilters: [],
            timeLeft: null
        };
        this.filterResetTimer = null;
        this.countdownInterval = null;
    }

    onImage404 = (e) => {
        e.target.style.display = "none";
    };

    toggleFilter(index) {
        /**
         * The commented code is part of multi-select.
         */
        // const { selectedFilters } = this.state;
        // const updatedFilters = selectedFilters.includes(index)
        //     ? selectedFilters.filter(i => i !== index) // Deselect
        //     : [...selectedFilters, index];             // Select
        //
        // this.setState({ selectedFilters: updatedFilters });
        // console.log(this.state.selectedFilters);

        const { selectedFilters } = this.state;
        const { filterButtons } = this.state;

        let updatedFilters;
        let updatedFilterStrings;
        let isExclusionSearch = false;

        if (this.filterResetTimer) {
            clearTimeout(this.filterResetTimer);
            this.filterResetTimer = null;
        }
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }

        if (selectedFilters.includes(index)) {
            updatedFilters = []
            updatedFilterStrings = [];
            this.setState({ timeLeft: null });
        } else {
            updatedFilters = [index];
            if (filterButtons[index].searchKeyWords) {
                updatedFilterStrings = filterButtons[index].searchKeyWords;
                isExclusionSearch = false;
            } else if (filterButtons[index].excludeKeyWords) {
                updatedFilterStrings = filterButtons[index].excludeKeyWords;
                isExclusionSearch = true;
            }

            ServiceLocator.ZTrack.Cast({
                counter: "click",
                kingdom: "right-rail",
                phylum: "filter",
                zClass: filterButtons[index].key,
                family: (this.props.fromFriends ? "zfriends" : "zynga"),
                genus: "attempt"
            });

            const resetAfterSeconds = 2 * 60;
            this.setState({ timeLeft: resetAfterSeconds });

            /**
             * This will help in updating timer in the filter UI
             * @type {number}
             */
            this.countdownInterval = setInterval(() => {
                this.setState(prev => {
                    if (prev.timeLeft <= 1) {
                        clearInterval(this.countdownInterval);
                        this.countdownInterval = null;
                        return { timeLeft: null };
                    }
                    return { timeLeft: prev.timeLeft - 1 };
                });
            }, 1000);

            this.filterResetTimer = setTimeout(() => {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
                updatedFilters = [];
                updatedFilterStrings = [];
                this.setState({ selectedFilters: [], timeLeft: null });
                Farm2FeedController.SetFilterStrings([], false);
            }, resetAfterSeconds * 1000);
        }

        this.setState({ selectedFilters: updatedFilters }, () => {
            Farm2FeedController.SetFilterStrings(updatedFilterStrings, isExclusionSearch)
        });
    }

    renderTimer = () => {
        const { timeLeft } = this.state;
        if (timeLeft == null) return null;

        const minutes = Math.floor(timeLeft / 60);
        const seconds = timeLeft % 60;
        return (
            <span className="ms-2 text-muted">
                <i className="fa fa-hourglass fa-spin ms-2 ml-3"></i>
                    &nbsp;{minutes}:{seconds.toString().padStart(2, '0')}
            </span>
        );
    }

    renderButtons = () => {
        const { filterButtons, selectedFilters } = this.state;

        return (
            <div className="d-flex flex-wrap gap-2 p-2">
                {filterButtons.map((btn, idx) => {
                    const isSelected = selectedFilters.includes(idx);
                    const buttonClass = `${isSelected ? "filter-button-selected" : "filter-button-deselected"}`;

                    return (
                        <div key={idx} className={`filter-wrapper ${isSelected ? "selected" : ""}`} style={{ transition: "transform 0.2s ease" }}>
                            <Button
                                message={
                                    <span className="d-inline-flex align-items-center">
                                    {isSelected && (
                                        <i className="fa fa-check" aria-hidden="true"></i>
                                    )}
                                    <img
                                        src={process.env.REACT_APP_ASSET_PATH + btn.icon}
                                        alt="icon"
                                        onError={this.onImage404}
                                        className="filter-icon me-2"
                                    />
                                    {btn.label}
                                </span>
                                }
                                onClick={() => this.toggleFilter(idx)}
                                extraClass={buttonClass}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };


    render() {
        return (<div style={{ border: "2px solid black", borderRadius: "0.5rem" }}>
            <p className="h6 text-black filterSubHeader d-flex justify-content-between align-items-center mr-3">
                <span>
                    <i className="fa fa-star" aria-hidden="true"></i>
                    &nbsp;&nbsp;
                    <b>
                        {
                            LocUtils.T(
                                "pages.games.farm2.rail.feedFilter.title"
                            )
                        }
                    </b>
                </span>
                {this.renderTimer()}
            </p>
            <p className="h6 text-black filterInfoText">
                {
                    LocUtils.T(
                        "pages.games.farm2.rail.feedFilter.subtitle"
                    )
                }
            </p>
            {this.renderButtons()}
            {
                this.props.showNoFeedsMsg && (
                    <p className="friend-request-info-message d-block text-center">
                        {
                            LocUtils.T(
                                "pages.games.farm2.rail.feedFilter.feedNotPresentMsg"
                            )
                        }
                    </p>
                )
            }
        </div>);
    }
}

class Farm2Feeds extends BaseComponent {
    constructor(props) {
        super(props);
        this.CACHE_KEY = "FARM2_FEED_DATA";
        this.trickleList = [];
        this.pollFeedIntervalHandler = undefined;
        this.trickleIntervalHandler = undefined;
        this.feed_cache = {};
        this.user_cache = {};
        this.state = {
            fromFriends: false,
            trickleCompleteList: {
                friends: [],
                everybody: []
            },
            friendRequestSendLimitReached: false,
            showFilterViralNotPresentMsg: false
        }
        this.max_feeds = 20;
        this.requestedFriendsZids = []
        this.onSwitchChange = this.onSwitchChange.bind(this);
        this.userLookup = this.userLookup.bind(this);
        this.getFriendRequestState = this.getFriendRequestState.bind(this);
        this.setFriendRequestSendLimitReached = this.setFriendRequestSendLimitReached.bind(this);
    }

    userLookup(key) {
        return Farm2FeedController.UserLookup(key);
    }

    setFriendRequestSendLimitReached(value) {
        console.log("Joseph: Limit is set to " + value);
        this.setState({
            friendRequestSendLimitReached: value
        })
        //this.forceUpdate();
    }

    getFriendRequestState(azid) {
        /**
         * This feature is experiment gated
         */
        if (ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.SideRail.ADD_FRIEND_MASTER_EXPERIMENT) === 2) {
            return this.requestedFriendsZids.includes(azid) ? 1 : 0;
        } else {
            return -1;
        }
    }

    onSwitchChange(value) {
        this.setState({
            fromFriends: value
        })
    }

    componentDidMount() {
        // Load the undefined user for future user
        ServiceLocator.SocialNetworkManager.People.Directory.Identify("undefined");
        Farm2FeedController.Init({
            that: this,
            csrf: this.props.data.csrf,
            zid: this.props.data.zid,
            zFriends: this.props.zFriends,
            gameKey: this.props.gameKey,
            gameId: this.props.gameId
        });

        ServiceLocator.SocialNetworkManager.People.GetSentInvites((data) => {
            this.requestedFriendsZids = data;
        });
    }

    componentWillUnmount() {
        Farm2FeedController.Clear();
    }

    componentDidUpdate() {
        setTimeout(() => {
            console.log("ifram hei:", $("#farm2-game-iframe").height())
            $("#farm2-feed-list-container").height($("#farm2-game-iframe").height() - $("#feed-toggle-container").height() - $("#rail-header-container").height());
        }, 3000);
    }

    addRequestedFriendZid(zid) {
        console.log("Joseph: addRequest is called with " + zid);
        if (!this.requestedFriendsZids.includes(zid)) {
            this.requestedFriendsZids.push(zid);
            this.forceUpdate(); // Force re-render to update friend state
        }
    }

    render() {
        return (
          <div className="farm2-feed-rail">
            <ToggleSwitch onSwitchChange={this.onSwitchChange} />
            <div
              id="farm2-feed-list-container"
              className="farm2-feed-list feed-scroll rounded-corners-top-neg rounded-corners-bottom"
            >
              {this.state.fromFriends === true && (
                <div className="row no-gutters">
                  <div className="col">
                    <SuggestedFriends />
                  </div>
                </div>
              )}
              <div className="row no-gutters">
                <div className="col">
                  <p className="h6 text-black feedSubHeader">
                    <i className="fa fa-id-card" aria-hidden="true"></i>
                    &nbsp;&nbsp;
                    <b>
                      {this.state.fromFriends
                        ? LocUtils.T(
                            "pages.games.farm2.rail.section.myZFriends"
                          )
                        : LocUtils.T(
                            "pages.games.farm2.rail.section.everybody"
                          )}
                    </b>
                  </p>
                    {ServiceLocator.OptimizationManager.EOS.GetExperimentVariant(SiteConstants.SideRail.FILTER_MASTER_EXPERIMENT) === 2 && (
                        <FeedFilter
                            showNoFeedsMsg={this.state.showFilterViralNotPresentMsg}
                            fromFriends={this.state.fromFriends}
                        />
                    )}
                    {this.state.friendRequestSendLimitReached && (
                        <span className="friend-request-info-message d-block text-center">{LocUtils.T("pages.games.farm2.rail.friends.limit_info")}</span>
                    )}
                  {/*
                                Transition group will take care of the easing transition 
                                whenever a new feed bubble appears. 
                                Refer npm: https://www.npmjs.com/package/react-flip-move 
                            */}
                  {this.state.fromFriends === true && this.state.trickleCompleteList.friends.length > 0 && (
                    <FlipMove duration={1050} easing="ease">
                      {this.state.trickleCompleteList.friends.map((data) => {
                        return (
                          <Farm2FeedX
                            key={data.id}
                            data={data}
                            authData={this.props.data}
                            userLookup={this.userLookup}
                          />
                        );
                      })}
                    </FlipMove>
                  )}
                  {this.state.fromFriends === false && this.state.trickleCompleteList.everybody.length > 0 && (
                    <FlipMove duration={100} easing="ease">
                       {this.state.trickleCompleteList.everybody.map((data) => {
                        return (
                          <Farm2FeedX
                            key={data.id}
                            data={data}
                            authData={this.props.data}
                            userLookup={this.userLookup}
                            getFriendRequestState={this.getFriendRequestState}
                            addRequestedFriendZid={this.addRequestedFriendZid.bind(this)}
                            setFriendRequestSendLimitReached={this.setFriendRequestSendLimitReached.bind(this)}
                            isFriendRequestSendLimitReached={this.state.friendRequestSendLimitReached}
                          />
                        );
                      })}
                    </FlipMove>
                  )}
                  {this.state.fromFriends === true && this.state.trickleCompleteList.everybody.length < 1 && (
                    <p className="h6 text-black feedSubHeader" style={{ paddingTop: "3rem" }}>
                      <i>
                        {LocUtils.T(
                          "pages.games.farm2.rail.no_content.description"
                        )}
                      </i>
                    </p>
                  )}
                  {this.state.fromFriends === false && this.state.trickleCompleteList.everybody.length < 1 && (
                    <p className="h6 text-black feedSubHeader" style={{ paddingTop: "3rem" }}>
                      <i>
                        {LocUtils.T(
                          "pages.games.farm2.rail.no_content.description"
                        )}
                      </i>
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
    }
}

export default Farm2Feeds;